import React from "react"
import Store from "./loginStore"
import Actions from "./LoginActions"
import { AccountData } from "../generated";
import DatesHelper from "../common/datesHelper";

export type WithUser = { user: AccountData };
export type WithOptionalUser = { user: AccountData | null };

export function requiresUser<TProps extends WithUser>(WrappedComponent: React.ComponentType<TProps>, options?: {
    loading?: React.ComponentType,
    loggetOut?: ((props: TProps) => React.ReactElement | null) | (() => void);
}) {
    return class InnerCmp extends React.Component<Omit<TProps, keyof WithUser>> {
        private listener = () => {
            this.forceUpdate();
        }
        componentDidMount() {
            Store.Changed.register(this.listener)
            if (!Store.isInitialized())
                Actions.getAccountInfo();

        }
        componentWillUnmount() {
            Store.Changed.unregister(this.listener)
        }

        render() {
            const Loading = options && options.loading;
            if (!Store.isInitialized())
                return Loading ? <Loading /> : null;
            const user = Store.get();
            if (user == null) {
                if (!options)
                    return null;
                const { loggetOut } = options;
                if (!loggetOut)
                    return null;
                return loggetOut(this.props as any) || null;
            }
            var WC = WrappedComponent as any;
            const props = this.props!;
            return (<WC {...props} user={user} />);
        }
    }
}

export function canRequireUser<TProps extends WithOptionalUser>(WrappedComponent: React.ComponentType<TProps>, loading?: React.ComponentType) {
    return class InnerCmp extends React.Component<Omit<TProps, keyof WithOptionalUser>> {

        private listener = () => {
            this.forceUpdate();
        }
        componentDidMount() {
            Store.Changed.register(this.listener)
            if (!Store.isInitialized())
                Actions.getAccountInfo();

        }
        componentWillUnmount() {
            Store.Changed.unregister(this.listener)
        }

        render() {
            const Loading = loading;
            if (!Store.isInitialized())
                return Loading ? <Loading /> : null;
            const user = Store.get();
            var WC = WrappedComponent as any;
            return (<WC {...this.props} user={user} />);
        }
    }
}

export function accountIsExpired(user: AccountData | null) {
    return user && (user.expiration < new Date()) || false;
}

export function getRemainingDays(expiration: Date) {
    const now = new Date();
    const absRemainingDays = DatesHelper.differenceInDays(expiration, now).days;
    return expiration >= now ? absRemainingDays : absRemainingDays * -1;
}

export function getExpirationDescription(remaingDays: number) {
    if (remaingDays >= 0) {
        return "La tua prova sta per terminare!";
    }
    else {
        return "La tua prova è terminata!";
    }
}

export function getRemaningDaysDescription(remaingDays: number) {
    if (remaingDays > 1) {
        return `mancano ${remaingDays} giorni`;
    }
    else if (remaingDays === 1) {
        return `manca 1 giorno`;
    }
    else if (remaingDays === 0) {
        return `mancano poche ore`;
    }
    else {
        return "La tua prova è terminata!";
    }

}